module.exports = __webpack_public_path__ + "a29126ccea2fba157c0a7cf754b1bf18.svg";